// extracted by mini-css-extract-plugin
export default {"wrapper":"DropzoneButton_wrapper__mxMKz","dropzone":"DropzoneButton_dropzone__ylV3J","control":"DropzoneButton_control__t7mG1"};